import EmptyPlaceholder from '../../commons/EmptyPlaceholder';

const QuestionEmpty = () => {
  return <EmptyPlaceholder placeholder="Aucunes questions créées" />;
};

export default QuestionEmpty;
